import "animate.css";
import React from "react";
import Particles from "react-particles-js";
import Header from "./header";
import About from "./about";
import Services from "./services";
import Clients from "./clients";
import Team from "./team";
import Social from "./social";
import Work from "./work";
import Contact from "./contact_us";
import Projects from "./projects";
import PrivacyPolicy from "./privacyPolicy";
import SocialLink from "./social_link";
import Footer from "../containers/footer/Footer";
import Typewriter from "typewriter-effect";
import { Link } from "react-router-dom";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updated: false,
      page: "home",
      projects: false,
      clients: false,
      team: false,
      social: false,
      services: false,
      about: false,
      showPopup: false,
    };
  }
  componentDidMount() {
    document.addEventListener("scroll", this.trackScrolling);
    if (window.location.hash) {
      this.trackScrolling(null, window.location.hash);
    }
    var hashUrl = window.location.hash.split("#")[1];
    var scrollToElement = document.getElementById(hashUrl);
    if (hashUrl && hashUrl.includes("/")) {
      scrollToElement = document.getElementById(hashUrl.split("/")[0]);
    }
    if (
      scrollToElement &&
      (scrollToElement.id === "privacypolicy" ||
        scrollToElement.id === "contact")
    ) {
      //scrollToElement.scrollIntoView()
      window.scrollTo({
        top: scrollToElement.offsetTop + 3000,
        behavior: "instant",
      });
    }
  }
  componentWillUpdate() {
    document.addEventListener("scroll", this.trackScrolling);
  }

  isBottom(el) {
    return el && el.getBoundingClientRect().top <= window.innerHeight;
  }
  trackScrolling = (event, hashValue) => {
    // console.log('EVENT', event.target.id)
    const servicesContainer = document.getElementById("servicesContainer");
    const aboutContainer = document.getElementById("aboutContainer");
    const teamContainer = document.getElementById("teamContainer");
    const clientContainer = document.getElementById("clientContainer");
    const socialContainer = document.getElementById("socialContainer");
    const projectContainer = document.getElementById("projectContainer");
    if (hashValue) {
      if (
        hashValue === "#projects" &&
        document.getElementById("projects") === null
      ) {
        const updated = !this.state.updated;
        this.setState({ updated, page: "projects", projects: true });
      } else if (
        hashValue === "#clients" &&
        document.getElementById("clients") === null
      ) {
        const updated = !this.state.updated;
        this.setState({ updated, page: "clients", clients: true });
      } else if (
        hashValue === "#team" &&
        document.getElementById("team") === null
      ) {
        const updated = !this.state.updated;
        this.setState({ updated, page: "team", team: true });
      } else if (
        hashValue === "#social" &&
        document.getElementById("social") === null
      ) {
        const updated = !this.state.updated;
        this.setState({ updated, page: "social", social: true });
      } else if (
        hashValue === "#services" &&
        this.isBottom(servicesContainer)
      ) {
        if (!this.state.services) {
          this.setState({ page: "services", services: true });
        }
      } else if (this.isBottom(aboutContainer)) {
        if (!this.state.about) {
          this.setState({ page: "about", about: true });
        }
      }
    } else if (event) {
      if (
        (this.isBottom(projectContainer) ||
          event.target.id === "navProjects") &&
        document.getElementById("projects") === null
      ) {
        const updated = !this.state.updated;
        this.setState({ updated, page: "projects", projects: true });
      } else if (
        (this.isBottom(clientContainer) || event.target.id === "navClient") &&
        document.getElementById("clients") === null
      ) {
        const updated = !this.state.updated;
        this.setState({ updated, page: "clients", clients: true });
      } else if (
        (this.isBottom(teamContainer) || event.target.id === "navTeam") &&
        document.getElementById("team") === null
      ) {
        const updated = !this.state.updated;
        this.setState({ updated, page: "team", team: true });
      } else if (
        event.target.id === "navSocial" &&
        document.getElementById("social") === null
      ) {
        const updated = !this.state.updated;
        this.setState({ updated, page: "social", social: true });
      } else if (
        this.isBottom(servicesContainer) &&
        event.target.id === "navServices"
      ) {
        if (!this.state.services) {
          this.setState({ page: "services", services: true });
        }
      } else if (
        this.isBottom(aboutContainer) &&
        event.target.id === "navAbout"
      ) {
        if (!this.state.about) {
          this.setState({ page: "about", about: true });
        }
      }
    }
  };

  render() {
    return (
      <div
        id="home"
        style={{
          backgroundColor: "black",
        }}
        className="noselect"
      >
        <div id="particles-js">
          <div className="banner-caption">
            <div className="container-fluidpad">
              <div className="row">
                <div
                  className="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 "
                  data-animation-effect="fadeIn"
                  style={{
                    height: "100% !important",
                    position: "absolute",
                  }}
                >
                  <div className="site-name" />
                  <div id="a1" className="lead text-center f-weight fnt">
                    <div id="thoughtBubble" className="thought-bubble">
                      <div>
                        <h1 className="text-center">
                          Welcome to
                          <div style={{ display: "flex" }}>
                            <Typewriter
                              onInit={(typewriter) => {
                                typewriter
                                  .typeString(" NicheSoft")
                                  .callFunction(() => {
                                    console.log("String typed out!");
                                  })
                                  .pauseFor(800)
                                  .deleteChars(2)
                                  .typeString("lv")
                                  .callFunction(() => {
                                    console.log("All strings were deleted");
                                    this.setState({ showPopup: true });
                                  })
                                  .start();
                              }}
                            />
                            {this.state.showPopup && (
                              <Link to="/rebrand">
                                <div className="animate__animated animate__zoomIn circularLayout">
                                  <div class="circular" id="circularPopup">
                                    We’ve
                                    <br></br>rebranded!
                                  </div>
                                </div>
                              </Link>
                            )}
                          </div>
                        </h1>
                      </div>
                    </div>
                    <font color="white">
                      A Software engineering company with design and development
                      capabilities in full stack Web, Mobile, AI/ML( Deep
                      Learning, NLP, Computer Vision), Cloud & IoT.
                      <br />
                      <br />
                      Technology Partner to high growth start ups & global
                      enterprises in domains such as Networking, Block chain,
                      e-Commerce, BFSI, Industrial Automation, Architecture,
                      Engineering & Construction, Airlines, Transport,
                      Logistics, Travel & Leisure
                    </font>
                  </div>
                </div>
              </div>
            </div>
            <SocialLink />
          </div>
          {}
          <Particles
            params={{
              particles: {
                number: {
                  value: 65,
                  density: {
                    enable: !0,
                    value_area: 800,
                  },
                },
                class: "particles-js-canvas-el",
                color: {
                  value: "#9ACD32",
                },
                shape: {
                  type: "circle",
                  stroke: {
                    width: 0,
                    color: "#000000",
                  },
                  polygon: {
                    nb_sides: 5,
                  },
                  image: {
                    src: "img/github.svg",
                    width: 100,
                    height: 100,
                  },
                },
                opacity: {
                  value: 0.5,
                  random: !1,
                  anim: {
                    enable: !1,
                    speed: 1,
                    opacity_min: 0.1,
                    sync: !1,
                  },
                },
                size: {
                  value: 5,
                  random: !0,
                  anim: {
                    enable: !1,
                    speed: 40,
                    size_min: 0.1,
                    sync: !1,
                  },
                },
                line_linked: {
                  enable: !0,
                  distance: 160,
                  color: "#ffffff",
                  opacity: 0.4,
                  width: 1,
                },
                move: {
                  enable: !0,
                  speed: 6,
                  direction: "none",
                  random: !1,
                  straight: !1,
                  out_mode: "out",
                  attract: {
                    enable: !1,
                    rotateX: 600,
                    rotateY: 1200,
                  },
                },
              },
              interactivity: {
                detect_on: "canvas",
                height: "100%",
                events: {
                  onhover: {
                    enable: !0,
                    mode: "repulse",
                  },
                  onclick: {
                    enable: !0,
                    mode: "push",
                  },
                  resize: !0,
                },
                modes: {
                  grab: {
                    distance: 400,
                    line_linked: {
                      opacity: 1,
                    },
                  },
                  bubble: {
                    distance: 400,
                    size: 40,
                    duration: 2,
                    opacity: 8,
                    speed: 3,
                  },
                  repulse: {
                    distance: 200,
                  },
                  push: {
                    particles_nb: 4,
                  },
                  remove: {
                    particles_nb: 2,
                  },
                },
              },
              retina_detect: !0,
              config_demo: {
                hide_card: !1,
                background_color: "#b61924",
                background_image: "",
                background_position: "50% 50%",
                background_repeat: "no-repeat",
                background_size: "cover",
              },
            }}
            height={803}
          />
        </div>
        <div>
          <div id="fb-root" />
          <div className="scrollToTop">
            <i className="icon-up-open-big" />
          </div>
          <Header trackScrolling={this.trackScrolling} page={this.state.page} />
          <div id="aboutContainer">
            <About id="about" />
          </div>
          <div id="servicesContainer">
            <Services />
          </div>
          <div className="default-bg space blue">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
                  <h1 className="text-center">Let's Work Together!</h1>
                </div>
              </div>
            </div>
          </div>

          <div
            id="projectContainer"
            className="prjt"
            style={{ minHeight: "1000px" }}
          >
            {this.state.projects ? <Projects /> : null}
          </div>
          <div id="clientContainer" style={{ minHeight: "500px" }}>
            {this.state.clients ? <Clients /> : null}
          </div>
          <div id="teamContainer">{this.state.team ? <Team /> : null}</div>
          <div id="socialContainer">
            {this.state.social ? <Social /> : null}
          </div>

          <Work />
          <div id="contact">
            <Contact />
          </div>

          <div id="privacypolicy">
            <PrivacyPolicy />
          </div>
          <div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}
export default Home;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/home.js